import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { i18n } from "@/i18n";
import '@/assets/css/fonts.css'; // 引入字体样式文件
import AOS from 'aos';
import 'aos/dist/aos.css';

import {
  Button,
  RadioGroup,
  RadioButton,
  Menu,
  MenuItem,
  Image,
  Form,
  FormItem,
  Select,
  Option,
  Carousel,
  CarouselItem,
} from 'element-ui';
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Image);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.config.productionTip = false;

// 初始化 AOS（动画滚动效果）
AOS.init({
  offset: 80,
  duration: 500,       // 动画时长
  easing: 'ease-in-out', // 动画缓动效果
  once: true,           // 动画只执行一次
  mirror: false,        // 禁用镜像模式
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
